import { Click }                from '../click/click.class'
import { NumberInputManager }   from '../numberInputManager/numberInputManager.class'
import { ICONS }                from '../../constants/icons/icons.constant'
import { MENU_BUTTON_CONFIG }   from '../../constants/button/menu-button-config.constant'
import { BUTTON_CONFIG }        from '../../constants/button/button-config.constant'
import { Action }               from '../action/action.class'
import { getZIndex }            from '../../functions/get-zindex.function'

//Sound settings mobile icon
import * as soundSettingsActiveLs from '../../assets/mobile/landscape/menu-footer/sound/mb-ls-btn-bright-sound-active.png'

//Spin settings mobile icon
import * as spinSettingsActiveLs from '../../assets/mobile/landscape/menu-footer/spin/mb-ls-btn-bright-spin-active.png'

//Autospin settings mobile icon
import * as autospinSettingsActiveLs from '../../assets/mobile/landscape/menu-footer/autospin/mb-ls-btn-bright-autospin-active.png'

//History mobile icon
import * as historyActiveLs from '../../assets/mobile/landscape/menu-footer/history/mb-ls-btn-bright-history-active.png'

//Bet settings mobile icon
import * as betSettingsActiveLs from '../../assets/mobile/landscape/menu-footer/bet/mb-ls-btn-bright-bet-active.png'

/**
 * @file Defines the {@link MenuManager} class
 * @author <joe.thompson@1x2network.com>
 * @version 1.0.30
 */

 /** Class for loading & displaying menu icons for mobile */
 export class MenuManager {

    /**
     * Array for storing all icons in submenu
     * @memberof MenuManager
     * @protected
     * @instance
     * @type {string[]}
     */
    _icons
    
    /**
     * Array for storing all image data uri's
     * @memberof MenuManager
     * @protected
     * @instance
     * @type {string[]}
     */
    _imgs

    /**
     * HTMLDivElement containing desktop menu container node
     * @memberof MenuManager
     * @protected
     * @instance
     * @type {HTMLDivElement}
     */
    _menuDesktop

    /**
     * NodeList containing all pages in settings
     * @memberof MenuManager
     * @protected
     * @instance
     * @type {NodeList}
     */
    _pages

    /**
     * HTMLCollection containing all sections in desktop menu
     * @memberof MenuManager
     * @protected
     * @instance
     * @type {HTMLCollection}
     */
    _sections

    /**
     * Array storing titles of each page in settings
     * @memberof MenuManager
     * @protected
     * @instance
     * @type {string[]}
     */
    _titles

    /**
     * Object mapping icons to page ID'
     * @memberof MenuManager
     * @protected
     * @instance
     * @type {Object<string, string>}
     */
    _map

    /**
     * Menu button click event handler
     * @memberof MenuManager
     * @protected
     * @instance
     * @type {Action}
     */
    onClick

    /**
     * Load new UI menu icons into iron dog framework
     * @param {Promise<undefined>} helpLoaded_ Promise for when help file loaded
     */
    constructor(helpLoaded_) {

        this._imgs      = [] //Create empty array to store image data uri's
        this.onClick    = new Action()

        //If mobile
        if (framework.isTouch()) {

            new NumberInputManager() //Initialize number input manager

            //Store sound settings data uri's
            this._imgs.push(soundSettingsActiveLs)

            //Store spin settings data uri's
            this._imgs.push(spinSettingsActiveLs)

            //Store autospin settings data uri's
            this._imgs.push(autospinSettingsActiveLs)

            //Store history data uri's
            this._imgs.push(historyActiveLs)

            //Store bet settings data uri's
            this._imgs.push(betSettingsActiveLs)

            //Store home data uri's
            this._imgs.push(ICONS.home)

            //Store exit button icon
            this._imgs.push(ICONS.exit.desktop)

            //Store menu footer node
            let menuFooter = document.getElementById('menuMobile').getElementsByTagName('footer')[0]

            //Store li nodes for each setting
            let liNodes = menuFooter.children[0].children

            //Loop through menu settings
            for (let i = 0; i < this._imgs.length; i++) {

                let setting //Define variable for storing setting node

                //If setting already exists in iron dog framework
                if (liNodes[i]) {

                    setting = liNodes[i]    //Store setting node

                    //If sound setting
                    if (i === 0) {

                        setting.addEventListener('touchstart', () => this.adjustButtonsDescription('mob'))
                        setting.removeChild(setting.children[0])
                        setting.classList.add('fa-icon')
                        setting.innerHTML   = ICONS.gameGuide

                    }

                    //If autoplay settings
                    if (i === 2) {

                        //If autoplay disabled
                        if (true) {
                            setting.classList.add('hidden')
                        }

                    }

                    //If coins setting
                    if (i === 4) {

                        //If coins disabled
                        if (!getCanCoins_()) {
                            setting.classList.add('hidden')
                        }

                    }

                    //Any other setting
                    if (i !== 0) {
                        setting.children[0].src = this._imgs[i] //Set footer setting image
                    }

                }

                //Exit setting
                else {

                    //Load in exit icon
                    let li = document.createElement('li')
                    li.id  = 'exitMenu'
                    li.classList.add('fa-icon')
                    li.innerHTML = ICONS.exit.desktop

                    document.getElementById('menuMobile').children[1].children[0].appendChild(li) //Add to menu footer
                    
                }

                let li     = document.getElementById('menuMobile').children[1].querySelectorAll('ul')[0].children[i] //Retrieve li node
                let circle = document.createElement('span')                                                          //Create circle span
                circle.classList.add('circle')                                                                       //Add circle styling
                li.appendChild(circle)                                                                               //Add circle to li node

            }

            setTimeout(() => this.combine(helpLoaded_), 500)                //Combine sound settings into spin setitngs page
            this.onClick.add(() => this.adjustButtonsDescription('mob'))    //Adjust buttons description to show only buttons avaliable

        }

        //Desktop
        else {

            this._icons       = [ 'history', 'home', 'help', 'settings' ]        //Create array for storing icons in sub menu
            this._titles      = [ 'Settings', 'Game History', 'Game Guide' ]     //Create array for each setting page title
            this._menuDesktop = document.getElementById('menuContainer')         //Store desktop menu container node

            //Initialise mapping of icons to pages
            this._map = {

                'gameHistory':  'gameHistoryPage',
                'help':         'helpPage',
                'settingsTab':  'settingsTabPage'

            }

            //Store menu icons to imgs array
            this._imgs.push(ICONS.settings)
            this._imgs.push(ICONS.history)
            this._imgs.push(ICONS.gameGuide)
            this._imgs.push(ICONS.exit.desktop)

            //Store all setting page nodes
            this._pages = document.getElementsByClassName('menu__content')[2].querySelectorAll('section.menu__section')

            this._menuDesktop.appendChild(this.sidebar()) //Generate sidebar and add to menu container

            let pagesContainer  = this._menuDesktop.children[0].children[1] //Retrieve container storing pages in menu

            //Once help loaded add help file to menu
            helpLoaded_.then(() => pagesContainer.appendChild(this.gameGuide()))

            //Loop through setting page nodes
            for (let i = 0; i < this._pages.length; i++) {

                //Create div to store setting page title
                let titleDiv       = document.createElement('div')
                titleDiv.innerHTML = Translate.do(this._titles[i])
                titleDiv.classList.add('menu-title')

                //Add title to top of setting page
                let ul = this._pages[i].querySelectorAll('ul')[0]
                this._pages[i].insertBefore(titleDiv, ul)

            }

            this.submenu() //Handle sub menu click handlers

        }

    }

    /** Get onClick */  get onClick()   { return this.onClick }

    /** Generate click handlers for submenu icons on console page */
    submenu() {

        let submenu = document.getElementsByClassName('sub__menu__icon') //Store sub menu node

        //Loop through sub menu
        for (let i = 0; i < submenu.length; i++) {

            let node = submenu[i]                          //Store sub menu node
            let icon = node.querySelectorAll('img')[0].src //Store node image

            //For each icon in sub menu
            this._icons.forEach(i_ => {

                //If icon is for that page and is not lobby/home button
                if (icon.includes(i_) && i_ !== 'home') {

                    node.id = `${i_}Icon`                          //Generate unique ID for each sub menu node
                    new Click(node, this.submenuClick, this, node) //Add click handler

                }

            })

        }

    }

    /**
     * Click handler for accessing setting page via submenu in console
     * @param {object} this_ - Reference to class's scope
     * @param {object} elem_ - Reference to submenu div node
     */
    submenuClick(this_, elem_) {

        //If Session bar in use
        if (window.f1x2.SESSION_BAR && window.f1x2.SESSION_BAR.use) {

            let sessionBar = Array.from(document.querySelectorAll('.gf-session-bar'))[0]    //Store GF session bar node

            //If using our GF session bar
            if (sessionBar) {
                document.getElementById('mainViewport').style.zIndex = window.getComputedStyle(sessionBar).zIndex - 1   //Display session bar on top of menu
            }

        }

        //For each icon
        this_._icons.forEach(p_ => {

            //Generate ID for sub menu icon div
            let p = `${p_}Icon`

            //If icon is the icon from sub menu user has clicked and is not lobby button
            if (elem_.id === p && p_ !== 'home') {
                
                let icons = document.getElementById('menu-sidebar').querySelectorAll('ul')[0].children //Store sidebar icon nodes

                //Loop through sidebar icons
                for (let i = 0; i < icons.length; i++) {

                    let icon   = icons[i]                         //Store icon node
                    let pageID = icon.id.replace(/Icon/g, 'Page') //Retrieve pageID for each setting page based off icon
                    icon.classList.remove('active')               //Remove active styling

                    let newPage, oldPage //Create variables to store ID's of possible pages user can navigate to

                    //If user is opening settings page
                    if (elem_.id === 'settingsIcon') {

                        //Set pages user is navigating to & from
                        newPage = 'settingsTabPage'
                        oldPage = 'gameHistoryPage'

                    }

                    //User opening game history page
                    else {

                        //Set pages user is navigating to & from
                        oldPage = 'settingsTabPage'
                        newPage = 'gameHistoryPage'

                    }

                    //Remove any inline styling on setting pages from ironDog's fadeElement class
                    document.getElementById(pageID) && document.getElementById(pageID).removeAttribute('style')

                    //If page is the one user is navigating to
                    if (pageID === newPage) {

                        let btn = document.getElementById('menuButton') //Store menu button node

                        document.getElementById(newPage).classList.remove('hidden') //Show new page
                        document.getElementById(oldPage).classList.add('hidden')    //Hide old page

                        icon.classList.add('active') //Add active styling to relevant icon

                        //Navigate to page
                        newPage === 'gameHistoryPage' ? window.MainMenu.toggleMenu(1, this_._menuDesktop, btn) : window.MainMenu.toggleMenu(0, this_._menuDesktop, btn)

                    }

                    //Always hide help page
                    pageID === 'helpPage' && document.getElementById(pageID).classList.add('hidden')

                }

            }

        })

    }

    /**
     * Builds DOM for paytable sidebar
     * @return {object} Sidebar node to add
     */
    sidebar() {

        let desktopSections = [ 'settingsTab', 'gameHistory', 'help', 'exitMenu' ] //Create array for sidebar sections to be displayed

        //Create sidebar
        let sidebar = document.createElement('div')
        sidebar.id = 'menu-sidebar'

        let ul = document.createElement('ul') //Create an unordered list
        
        //Loop through sections
        for (let i = 0; i < desktopSections.length; i++) {

            //If setting page exists
            if (this._pages[i]) {
                this._pages[i].id = `${desktopSections[i]}Page` //Generate unique ID for setting page
            }

            //Load in section icon
            let li       = document.createElement('li')
            li.innerHTML = this._imgs[i]
            li.id        = `${desktopSections[i]}Icon`

            //If default setting page
            if (desktopSections[i] === 'settingsTab') {
                li.classList.add('active') //Add active styling to it's corresponding sidebar icon
            }

            //Add comment attribution
            let c = document.createComment('Credit: Font Awesome https://fontawesome.com/license')
            li.appendChild(c)

            //If not exit icon
            if (desktopSections[i] !== 'exitMenu') {
                new Click(li, this.click, this, li) //Add click handler
            }

            //Exit icon
            else {

                //Exit icon click handler
                let func = () => {

                    //If UK jurisdiction
                    if (loginVars.getRegParams().jurisdiction === 'uk') {
                        document.getElementById('mainViewport').style.zIndex = getZIndex('.gf-session-bar') + 1 //Display UI above session bar
                    }

                }

                new Click(li, func, this, li)   //Add click handler

            }

            ul.appendChild(li) //Add icon to list

        }

        sidebar.appendChild(ul) //Add list of icons to sidebar

        return sidebar //Return sidebar node

    }

    /**
     * Click handler for switching between pages in desktop menu
     * @param {object} this_ - Reference to class's scope
     * @param {object} elem_ - Reference to page icon node
     */
    click(this_, elem_) {

        let currentPage, newPage //Create variables for current setting page & new page user is navigating to

        let iconID  = elem_.id.replace(/Icon/g, '')                                                             //Store ID of page user wants to navigate to
        let icons   = Array.from(document.getElementById('menu-sidebar').querySelectorAll('ul')[0].children)    //Store icon nodes

        //Loop through icons
        icons.map(v_ => {

            //If icon is for active page
            if (v_.classList.contains('active')) {

                let currentIcon = v_.id.replace(/Icon/g, '')    //Get current icon
                currentPage     = this_._map[currentIcon]       //Store current page

            }

        })

        newPage = this_._map[iconID]    //Store new page user is navigating to

        //If user is viewing help file adjust buttons description to show only buttons avaliable
        newPage === 'helpPage' && this_.adjustButtonsDescription('menu')

        //Fade out current page
        fadeElement(document.getElementById(currentPage), 'out', () => {

            //Loop through icons
            for (let i = 0; i < icons.length; i++) {
                icons[i].classList.remove('active') //Remove active styling
            }

            //Fade page in via iron dog's fadeElement class & add active styling to icon
            fadeElement(document.getElementById(newPage), 'in', () => elem_.classList.add('active'))

        })

    }

    /**
     * Generates game guide to display in menu
     * @returns {HTMLElement} Game guide node
     */
    gameGuide() {

        let elem    = document.createElement('section')                         //Create game guide node
        elem.id     = 'helpPage'                                                //Add id
        elem.classList.add('menu__section', 'hidden', 'scrollable__content')    //Add styling

        let header          = document.createElement('div')                         //Create node to store game guide title
        header.id           = 'helpHeader'                                          //Add id
        header.innerHTML    = Translate.do(window.paytableAssets.pages[0].title)    //Translate header text
        header.classList.add('menu-title')                                          //Add styling
        elem.appendChild(header)                                                    //Add to game guide node

        let gameGuide   = document.getElementById('game-guide-content') //Retrieve game guide node from paytable

        let content = document.createElement('div') //Create node to store help file content
        content     = gameGuide.cloneNode(true)     //Clone game guide node from paytable

        let list = content.querySelectorAll('ul.buttons-list')  //Store node from paytable game guide with buttons description
        
        //Loop through button descriptions
        Array.from(list[0].children).map(v_ => {

            //If button is optional
            if (v_.id) {
                v_.id   = v_.id + '-menu'   //Add unique ID
            }

        })

        elem.appendChild(content)   //Add to game guide node

        return elem //Return game guide node

    }

    /**
     * Combine sound settings into spin settings 
     * @param {Promise<undefined>} helpLoaded_ Promise for when help file loaded
     */
    combine(helpLoaded_) {

        let soundPage       = document.getElementById('soundPage')              //Retrieve sound settings page
        let heading         = soundPage.querySelectorAll('h2')[0]               //Retrieve sound settings title node
        let soundSettings   = soundPage.querySelectorAll('ul.switch__list>li')  //Retrieve sound setitngs node
        let spinPage        = document.getElementById('spinPage')               //Retrieve spin settings page
        let spinList        = spinPage.querySelectorAll('ul.switch__list')[0]   //Retrieve spin settings list node

        heading.innerHTML   = Translate.do(window.paytableAssets.pages[0].title)    //Update title with game guide title

        Array.from(soundSettings).map(v_ => spinList.appendChild(v_))   //Add sound settings to spin settings list
        
        //Once help file loaded
        helpLoaded_.then(() => {

            let gameGuide   = document.getElementById('game-guide-content') //Retrieve game guide node from paytable
            let content     = document.createElement('div')                 //Create node to store help file content
            content         = gameGuide.cloneNode(true)                     //Clone game guide node from paytable
            content.classList.add('scrollable__content')                    //Add styling
            soundPage.appendChild(content)                                  //Add game guide to sound settings page

            let list = content.querySelectorAll('ul.buttons-list')  //Store node from paytable game guide with buttons description
        
            //If game guide node present
            if (list.length) {

                //Loop through button descriptions
                Array.from(list[0].children).map(v_ => {

                    //If button is optional
                    if (v_.id) {
                        v_.id   = v_.id + '-mob'   //Add unique ID
                    }

                })

            }

        })

    }

    /**
     * Adjust button descriptions to only show buttons avaliable in game
     * @param {string} postfix_ Unique ID added as postfix to optional button nodes
     */
    adjustButtonsDescription(postfix_) {

        let config = { ...BUTTON_CONFIG['console'], ...MENU_BUTTON_CONFIG } //Spread configs into 1 config object

        //Loop through buttons
        for (let b in config) {
    
            let texts = config[b].text //Retrieve button description texts
    
            //If button has button description texts
            if (texts.length > 0) {

                //If button optional
                if (config[b].optional) {

                    let { manager, func, negate, prop, override = () => { return true } } = config[b].optional.check //Destructure check-config

                    //If need to check IDS manager specific property
                    if (prop) {

                        //If button not in game
                        if (!window[manager][func]().prop) {

                            let elem = document.getElementById(`optional-${config[b].optional.id}-${postfix_}`) //Retrieve element node
                            elem && elem.classList.add('hidden')                                                //Hide from buttons description

                        }

                    }

                    //Only need to check IDS manager specific function
                    else {

                        //If manager class needs to be called
                        if (manager) {

                            //If button not in game
                            if (!window[manager][func]()) {

                                let elem = document.getElementById(`optional-${config[b].optional.id}-${postfix_}`) //Retrieve element node
                                elem && elem.classList.add('hidden')                                                //Hide from buttons description
                            
                            }

                            //Button in game
                            else {

                                //If override function is true
                                if (override()) {

                                    let elem = document.getElementById(`optional-${config[b].optional.id}-${postfix_}`) //Retrieve element node
                                    elem && elem.classList.add('hidden')                                                //Hide from buttons description
                                
                                }

                            }
                            
                        }

                        //Check function by calling directly on window object
                        else {

                            //If value should be negated
                            if (negate) {

                                //If button not in game
                                if (!window[func]()) {

                                    //If multiple sections needs hiding
                                    if (config[b].text && config[b].text.length > 1) {
                                        
                                       //Loop through sections
                                        for (let i = 0; i < config[b].text.length; i++) {

                                            //Hide section
                                            document.getElementById(`optional-${config[b].optional.id}-${i}-${postfix_}`).classList.add('hidden')

                                        }
                                    }

                                    //Single section needs hiding
                                    else {

                                        let elem = document.getElementById(`optional-${config[b].optional.id}-${postfix_}`) //Retrieve element node
                                        elem && elem.classList.add('hidden')                                                //Hide from buttons description
                                    
                                    }
                                    
                                }

                            }

                            //Value not to be negated
                            else {
                                
                                if (window[func]()) {
                                    //TODO (not need atm)
                                }

                            }

                        }

                    }

                }

            }

        }

    }

 }